import { render, staticRenderFns } from "./ResourceTile.vue?vue&type=template&id=e58dace8&scoped=true"
import script from "./ResourceTile.vue?vue&type=script&lang=js"
export * from "./ResourceTile.vue?vue&type=script&lang=js"
import style0 from "./ResourceTile.vue?vue&type=style&index=0&id=e58dace8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e58dace8",
  null
  
)

export default component.exports